<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="col-12">
              <div class="row">
                <div class="col-12 py-3 px-4 pt-4">
                  <h3
                    class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                  >
                    Administradores
                  </h3>
                  <div class="row">
                    <div class="form-group col-12 col-md-6 col-lg-5 mb-1 px-0">
                      <label for="">Búsqueda</label>
                      <input
                        type="text"
                        placeholder="Buscar"
                        class="form-control form-control-sm mt-1 mb-4"
                        v-model="searchQuery"
                        @input="loadElements(1)"
                      />
                    </div>
                    <div class="col-12 col-md-6 p-0 mb-3 pt-md-4 pl-md-5">
                      <div
                        class="d-flex justify-content-md-end pr-0 mr-0 pl-0 pl-md-5 pt-md-2"
                      >
                        <button
                          type="button"
                          class="bg-primary text-white font-weight-normal border btn-outline-primary h5 mb-0 btn"
                          @click="goNew"
                        >
                          Agregar Administrador
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive card">
                    <table class="table table-sm table-hover">
                      <thead class="thead-light">
                        <tr>
                          <th class="" scope="col">
                            <div class="font-weight-bold text-center">ID</div>
                          </th>
                          <th class="" scope="col">
                            <div class="font-weight-bold text-center">
                              Nombre
                            </div>
                          </th>
                          <th class="" scope="col">
                            <div class="font-weight-bold text-center">
                              Apellido
                            </div>
                          </th>
                          <th class="" scope="col">
                            <div class="font-weight-bold text-center">
                              Email
                            </div>
                          </th>
                          <th class="" scope="col">
                            <div class="font-weight-bold text-center">Rol</div>
                          </th>
                          <th class="" scope="col">
                            <div class="font-weight-bold text-center">
                              Opciones
                            </div>
                          </th>
                          <th class="d-none"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class=""
                          v-for="item in admins"
                          :key="item.referencia"
                        >
                          <td class="text-center">{{ item.id }}</td>
                          <td class="text-center">{{ item.first_name }}</td>
                          <td class="text-center">{{ item.last_name }}</td>
                          <td class="text-center">{{ item.email }}</td>
                          <td class="text-center">
                            {{ item.role.name || '' }}
                          </td>
                          <td class="text-center">
                            <div class="d-flex justify-content-center w-100">
                              <Tooltip text="Editar">
                                <button
                                  class="btn bg-warning border-0 p-2"
                                  @click="goEdit(item.id)"
                                >
                                  <i
                                    class="bi bi-pencil-square text-white d-flex justify-content-center align-items-center"
                                  ></i>
                                </button>
                              </Tooltip>

                              <Tooltip
                                :text="
                                  item.active === 1 ? 'Desactivar' : 'Activar'
                                "
                              >
                                <button
                                  class="btn border-0 mx-1 p-2"
                                  :class="{
                                    'bg-secondary': item.active === 0,
                                    'bg-success': item.active === 1
                                  }"
                                  @click="changeStatus(item.id, item.active)"
                                >
                                  <i
                                    v-if="item.active === 1"
                                    class="bi bi-check2-circle text-white d-flex justify-content-center align-items-center"
                                  ></i>
                                  <i
                                    v-else
                                    class="bi bi-eye-slash text-white d-flex justify-content-center align-items-center"
                                  ></i>
                                </button>
                              </Tooltip>

                              <Tooltip text="Eliminar">
                                <button
                                  class="btn bg-danger border-0 p-2 h-100"
                                  @click="
                                    changeStatus(item.id, item.active, true)
                                  "
                                >
                                  <i
                                    class="bi-trash3-fill text-white d-flex justify-content-center align-items-center"
                                  ></i>
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                          <td class="d-none"></td>
                        </tr>
                      </tbody>
                    </table>
                    <!--Paginacion-->
                    <div class="d-flex justify-content-center">
                      <nav aria-label="Page navigation example">
                        <ul class="pagination">
                          <li
                            class="page-item"
                            :class="{ disabled: currentPage === 1 }"
                          >
                            <a
                              class="page-link"
                              href="#"
                              @click.prevent="changePage(currentPage - 1)"
                              aria-label="Previous"
                            >
                              <span aria-hidden="true">&laquo;</span>
                            </a>
                          </li>
                          <li
                            class="page-item"
                            v-for="page in totalPages"
                            :key="page"
                          >
                            <a
                              class="page-link"
                              :class="{
                                'bg-primary ': page == currentPage,
                                'text-white': page === currentPage
                              }"
                              href="#"
                              @click.prevent="changePage(page)"
                              >{{ page }}</a
                            >
                          </li>
                          <li
                            class="page-item"
                            :class="{ disabled: currentPage === totalPages }"
                          >
                            <a
                              class="page-link"
                              href="#"
                              @click.prevent="changePage(currentPage + 1)"
                              aria-label="Next"
                            >
                              <span aria-hidden="true">&raquo;</span>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      admins: [],
      buttonNewUrl: 'NewAdministrators',
      buttonEditUrl: 'EditAdministrators',
      searchQuery: '',
      currentPage: 1,
      totalPages: 0,
      limit: 20
    }
  },
  methods: {
    ...mapActions(['getData', 'changeStatusData']),

    loadElements(page = 1) {
      const form = {
        url: 'admin/all',
        params: {
          query: this.searchQuery,
          page: page,
          limit: this.limit
        }
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.admins = response.data.data.sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at)
            )
            this.currentPage = response.data.meta.current_page
            this.totalPages = response.data.meta.last_page
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },

    changeStatus(id, active, isDelete = false) {
      let status
      let message
      if (isDelete) {
        status = 2
        message = '¿Estás seguro de eliminar el administrador?'
      } else {
        status = active === 0 ? 1 : 0
        message =
          active === 0
            ? '¿Estás seguro de activar el administrador?'
            : '¿Estás seguro de desactivar el administrador?'
      }

      const form = {
        url: 'admin/change_status',
        id,
        status
      }

      Swal.fire({
        title: 'Advertencia',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200 && status === 0) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El estado del administrador ha sido desactivado'
                })
                this.loadElements()
              } else if (response.code === 200 && status === 1) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El estado del administrador ha sido activado'
                })
                this.loadElements()
              } else if (response.code === 200 && status === 2) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El administrador ha sido eliminado'
                })
                this.loadElements()
              }
            })
            .catch((error) => {
              console.error(error)
            })
        }
      })
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.loadElements(page)
    },
    goNew() {
      this.$router.push({ name: this.buttonNewUrl })
    },
    goEdit(id) {
      this.$router.push({ name: this.buttonEditUrl, params: { id: id } })
    }
  },
  mounted() {
    this.loadElements()
  }
}
</script>

<style>
.text-h4 {
  color: #30476c !important;
}
.text-gray {
  color: #6c6c6c !important;
  font-weight: 300 !important;
}
tr:last-child td {
  border-bottom: 1px solid #dee2e6; /* Asegúrate de que la última fila tenga un borde inferior */
}
</style>
